import React, { memo } from 'react'

type SectionProps = {
  illust?: string
  bg?: string
  padding?: string
  maxWidth?: '960' | '1200' | string
  children: React.ReactNode
}

export const Section: React.FC<SectionProps> = memo(
  ({
    padding = 'lg:py-32 pb-16 pt-10 lg:px-0 px-6',
    bg = 'bg-formbg',
    illust,
    maxWidth = '1200',
    children
  }) => {
    const maxWidthClass = `max-w-[${maxWidth}px]`

    return (
      <section className={bg}>
        <div
          className={`text-center mx-auto ${padding} px-6 xl:px-0 ${maxWidthClass} w-full`}
        >
          {illust ? (
            <div className="relative">
              {children}
              {illust && (
                <img src={`/images/${illust}.svg`} alt="" className={illust} />
              )}
            </div>
          ) : (
            <>{children}</>
          )}
        </div>
      </section>
    )
  }
)

Section.displayName = 'Section'
